module.exports = __webpack_public_path__ + "img/farzana-christopher-51.1b34955f.jpg";